module.exports = __webpack_public_path__ + "img/img_whenIsUseful1.353650ca.png";